export default "__VITE_ASSET__BKEIn6oy__"